import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/zoom';
import Swiper from 'swiper';
import { EffectFade, Keyboard, Mousewheel, Navigation, Pagination, Thumbs, Zoom } from 'swiper/modules';
import { commonUtils } from './common_utils';

const fullscreenEventNames = [
    'fullscreenchange',
    'webkitfullscreenchange',
    'mozfullscreenchange',
    'MSFullscreenChange',
];

let fullscreenChangeHandler;

export const articleImageSlider = {
    swiperInstance: null,
    currentEscKeyHandler: null,

    init() {
        this.bindEvents();
    },

    teardownFullscreenViewer() {
        if (this.currentEscKeyHandler) {
            document.removeEventListener('keydown', this.currentEscKeyHandler);
            this.currentEscKeyHandler = null;
        }

        fullscreenEventNames.forEach((fullScreenEvent) =>
            document.removeEventListener(fullScreenEvent, fullscreenChangeHandler)
        );

        if (commonUtils.fullscreen.isActive()) {
            commonUtils.fullscreen.exit();
        }

        const $swiperLarge = $('.articleSwiperLarge');
        if ($swiperLarge[0]?.swiper) {
            $swiperLarge[0].swiper.destroy(true, true);
        }
        if (this.swiperInstance) {
            this.swiperInstance.destroy(true, true);
            this.swiperInstance = null;
        }

        $('body').removeClass('swiper-large-image-visible');

        $swiperLarge.hide();

        const mainSwiper = $('.swiperDetailPage')[0]?.swiper;
        if (mainSwiper?.keyboard) {
            mainSwiper.keyboard.enable();
        }
    },
    bindEvents() {
        // fullscreenChangeHandler is assigned after this object definition
        const $body = $('body');

        $body.on('click', '.articleSwiperLargeFullscreenImage', function (e) {
            e.preventDefault();

            const imageUrl = $(this).data('image-url');
            const imageAlt = $(this).data('image-alt') || '';

            // Check if article multi images section or content.
            const $parentLi = $(this).closest('li');
            const isFromSideBySideImages = $parentLi.hasClass('fr') || $parentLi.hasClass('fl');
            const $fullscreenSlider = $('#articleImageSwiper');

            let imagesToShow = [];
            let startIndex = 0; // Track which image to start with

            if (isFromSideBySideImages) {
                imagesToShow = ['fr', 'fl'] // article paragraph having multiple images
                    .map((cls) => $(`li.${cls} .articleSwiperLargeFullscreenImage`))
                    .filter(($img) => $img.length > 0)
                    .map(($img) => ({
                        url: $img.data('image-url'),
                        alt: $img.data('image-alt') || '',
                    }));

                startIndex = $parentLi.hasClass('fl') && imagesToShow.length > 1 ? 1 : 0;

                articleImageSlider.populateSwiper(
                    $fullscreenSlider,
                    imagesToShow.length > 0 ? imagesToShow : [{ url: imageUrl, alt: imageAlt }],
                    startIndex
                );
            } else {
                articleImageSlider.populateSwiper($fullscreenSlider, [{ url: imageUrl, alt: imageAlt }], 0);
            }

            if ($fullscreenSlider[0]) {
                commonUtils.fullscreen.open($fullscreenSlider[0]);
            }

            $fullscreenSlider.show();
            $body.addClass('swiper-large-image-visible');

            // Destroy existing swiper instance if it exists
            if (articleImageSlider.swiperInstance) {
                articleImageSlider.swiperInstance.destroy(true, true);
                articleImageSlider.swiperInstance = null;
            }

            // Initialize new Swiper instance
            articleImageSlider.swiperInstance = new Swiper($fullscreenSlider[0], {
                modules: [Navigation, Pagination, Thumbs, EffectFade, Keyboard, Zoom, Mousewheel],
                loop: imagesToShow.length > 1,
                speed: 0,
                mousewheel: {
                    sensitivity: 1.2, // More responsive than 0.3
                    thresholdDelta: 5, // Lower threshold for quicker response
                    thresholdTime: 250,
                },
                zoom: {
                    minRatio: 1,
                    maxRatio: 3,
                    toggle: true,
                    containerClass: 'swiperZoomContainer',
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                pagination: {
                    el: $fullscreenSlider.find('.swiper-pagination-large')[0],
                    type: 'custom',
                    renderCustom(swiper, current, total) {
                        return `${current}/${total}`;
                    },
                },
                navigation: {
                    nextEl: '.swiper-button-next-large',
                    prevEl: '.swiper-button-prev-large',
                    addIcons: false,
                },
                on: {
                    init() {
                        // Store the swiper instance for later reference
                        $fullscreenSlider[0].swiper = this;

                        // Set to the clicked image index
                        const initStartIndex = $fullscreenSlider.data('start-index') || 0;
                        this.slideTo(initStartIndex, 0);
                    },
                    beforeDestroy() {
                        this.zoom.out();
                    },
                },
            });

            // Add fullscreen change listeners using stable reference
            fullscreenEventNames.forEach((fullScreenEvent) =>
                document.addEventListener(fullScreenEvent, fullscreenChangeHandler)
            );

            // Apply custom changes for scroll + laptop touch-pad pinch zoom
            // Detect pinch/zoom gestures
            let isPinching = false;

            ['gesturestart', 'gestureend'].forEach((eventType) => {
                articleImageSlider.swiperInstance.el.addEventListener(
                    eventType,
                    (gestureEvt) => {
                        gestureEvt.preventDefault();
                        isPinching = eventType === 'gesturestart';
                    },
                    { passive: false }
                );
            });

            // Handle wheel events
            articleImageSlider.swiperInstance.el.addEventListener(
                'wheel',
                (wheelEvt) => {
                    // If it's a zoom gesture (Ctrl/Cmd + wheel or during pinch)
                    if (isPinching || wheelEvt.ctrlKey || wheelEvt.metaKey) {
                        // Let the zoom behavior happen naturally
                        articleImageSlider.swiperInstance.mousewheel.disable();
                        return;
                    }

                    // Re-enable mousewheel if we're not zooming
                    if (!articleImageSlider.swiperInstance.mousewheel.enabled) {
                        articleImageSlider.swiperInstance.mousewheel.enable();
                    }
                },
                { passive: true }
            );

            // Show/hide navigation buttons based on number of images
            const slideCount = $fullscreenSlider.find('.swiper-slide').length;
            if (slideCount > 1) {
                $fullscreenSlider.find('.swiper-button-next-large, .swiper-button-prev-large').show();
            } else {
                $fullscreenSlider.find('.swiper-button-next-large, .swiper-button-prev-large').hide();
            }

            articleImageSlider.currentEscKeyHandler = (event) => {
                if (event.key === 'Escape' || event.keyCode === 27) {
                    articleImageSlider.teardownFullscreenViewer();
                }
            };
            document.addEventListener('keydown', articleImageSlider.currentEscKeyHandler);

            return false;
        });

        // Close fullscreen slider when clicking the close button
        $body.on('click', '.swiperLargeViewClose', function () {
            articleImageSlider.teardownFullscreenViewer();
        });

        $body.on('click', '.swiper-large-view__bg', function () {
            articleImageSlider.teardownFullscreenViewer();
        });

        // Prevent closing when interacting with slider controls/content
        $body.on(
            'click',
            '.swiperLarge .swiper-wrapper, .swiperLarge .swiper-pagination-large, .swiperLarge .swiper-button-prev-large, .swiperLarge .swiper-button-next-large',
            function (e) {
                e.stopPropagation();
            }
        );
    },
    populateSwiper($swiperContainer, images, startIndex = 0) {
        const $swiperWrapper = $swiperContainer.find('.swiper-wrapper');
        $swiperWrapper.empty();

        const imageArray = Array.isArray(images) ? images : [{ url: images, alt: '' }];

        imageArray.forEach(function (imageData) {
            const slideHtml = `
                <div class="swiper-slide">
                    <div class="swiper-large-zoom-container swiperZoomContainer">
                        <img src="${imageData.url}" alt="${imageData.alt}" />
                    </div>
                </div>
            `;
            $swiperWrapper.append(slideHtml);
        });

        $swiperContainer.data('start-index', startIndex);
    },
};

fullscreenChangeHandler = function () {
    if (!commonUtils.fullscreen.isActive() && $('body').hasClass('swiper-large-image-visible')) {
        articleImageSlider.teardownFullscreenViewer();
    }
};
